import { IAoo, IArxeiaConfiguration, IFeature, IField, IRuolo, IUor, IUser } from '../../shared/interfaces'

export interface SessionState {
    currentUser?: IUser;
    currentAoo?: IAoo;
    userActiveAoo?: IAoo[];
    allRoles?: IRuolo[];
    features?: IFeature[];
    arxeiaConfigurations?: IArxeiaConfiguration[];
    currentUor?: IUor;
    isMobile?: boolean;
    isTablet?: boolean;
    sidebarMenuIsOpen?: boolean;
    aooMenuIsOpen?: boolean;
    indicePAFormFields: IField[],
    organigrammaFlat: IUor[]
}

export const UPDATE_SESSION = 'UPDATE_SESSION'
interface UpdateSessionAction {
    type: typeof UPDATE_SESSION
    payload: Partial<SessionState>
}

export type SessionActionTypes = UpdateSessionAction